// extracted by mini-css-extract-plugin
export var highlightOriginal = "_66-0";
export var highlightSuggested = "_66-1";